import BaseOption from "%/dynamic-component-editor/classes/base-option";
import { inspectorTools } from "%/dynamic-component-editor/inspector/inspector-tool-map";

export default class FallbackImage extends BaseOption {
  static userInterfaceComponent = {
    label: "Source",
    component: inspectorTools.MEDIA_PICKER,
    props: {
      mediaType: "image",
    },
  };

  static defaultValue = "";
}
